import { FormInput, FormSectionHeader, FormSelect, Loader } from "@/components";
import useTeamAssignment from "./useTeamAssignment";
import { FormProvider } from "react-hook-form";
import { EMP, NAME, PROJECT_CODE, ROLE, TEAM } from "./consts";

const TeamAssignment = () => {
  const {
    form,
    requiredFields,
    roleList,
    isLoadingRoles,
    employeeList,
    isEmployeeLoading,
    isLoadingTeam,
  } = useTeamAssignment();
  const { errors } = form.formState;

  return (
    <>
      {isLoadingRoles || isEmployeeLoading || isLoadingTeam ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form>
            <div className="bg-white mt-[20px] rounded-lg shadow-sm overflow-hidden ">
              <FormSectionHeader className="pt-[25px] px-[30px]">
                Team Info
              </FormSectionHeader>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] py-[25px] px-[30px]">
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="Project Name"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                  disabled
                />
                <FormInput
                  name={PROJECT_CODE}
                  control={form.control}
                  label="Project Code/ID"
                  placeholder="Please enter"
                  error={errors[PROJECT_CODE]?.message}
                  isRequired={requiredFields.includes(PROJECT_CODE)}
                  disabled
                />
              </div>
              <div className="bg-brown-200 col-span-2 gap-[20px] px-[30px] py-[25px]">
                <div className="grid grid-cols-1 gap-[20px]">
                  {form.watch(TEAM)?.map((_, index: any) => (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-[20px] items-center w-full">
                      <FormSelect
                        name={`${TEAM}.${index}.${ROLE}`}
                        control={form.control}
                        label="Role"
                        placeholder="Please enter"
                        error={
                          (errors as any)[`${TEAM}.${index}.${ROLE}`]?.message
                        }
                        isRequired={requiredFields.includes(
                          `${TEAM}.${index}.${ROLE}`
                        )}
                        disabled
                        options={(roleList?.data || [])?.map((data: any) => ({
                          label: data?.name,
                          value: data?.roleId?.toString(),
                        }))}
                      />
                      <FormSelect
                        name={`${TEAM}.${index}.${EMP}`}
                        control={form.control}
                        label="Employee"
                        placeholder="Please enter"
                        error={
                          (errors as any)[`${TEAM}.${index}.${EMP}`]?.message
                        }
                        isRequired={requiredFields.includes(
                          `${TEAM}.${index}.${EMP}`
                        )}
                        disabled
                        options={(employeeList?.data?.data || [])?.map(
                          (data: any) => ({
                            label: data?.fullName,
                            value: data?.userId?.toString(),
                          })
                        )}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      )}
    </>
  );
};

export default TeamAssignment;
